import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import HomeScreen from "../screens/homeScreen";
import CategoryScreen from "../screens/categoryScreen";
import LoginScreen from "../screens/loginScreen";
import RecuperarSenha from "../components/usuario/recuperar_senha";
import ContactScreen from "../screens/contactScreen";
// import professionalSignupScreen from "../screens/completeProfile/professionalSignupScreen.js";
import SignupScreen from "../screens/signupScreen";
import ProfessionalProfile from "../screens/profile/professional/professionalProfile";
import ProfileScreen from "../screens/profile/personal/profileScreen.js";
import CheckoutScreen from "../screens/payment/checkoutScreen.js";
import ProfessionalByCategoryScreen from "../screens/professionalByCategoryScreen";
import ComoFunciona from "../components/statics/como_funciona/como_funciona";
import Chat from "../components/chat/chat";
import Video from "../components/video/video";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { checkLoggedUser } from "../actions/index.js";
import { Link, Redirect } from "react-router-dom";
import ChatScreen from "../screens/chat/chatScreen";
import ConsultsScreen from "../screens/consults/consultsScreen";
import Header from "../components/header/header";
import FAQScreen from "../screens/faqScreen";
import professionalProfileScreen from "../screens/profile/personal/professionalProfileScreen";

class ControladorRotas extends Component {
  render() {
    return (
      <div style={{ overflowX: "hidden" }}>
        <Header />
        <Switch>
          <Route exact path="/" component={HomeScreen} />
          <Route exact path="/profile" component={ProfileScreen} />
          <Route
            exact
            path="/profile-professional"
            component={professionalProfileScreen}
          />
          <Route path="/credit/checkout" component={CheckoutScreen} />
          <Route path="/signup" component={SignupScreen} />
          <Route path="/categorias" component={CategoryScreen} />
          <Route path="/login" component={LoginScreen} />
          <Route path="/recuperar-senha" component={RecuperarSenha} />
          <Route path="/fale-conosco" component={ContactScreen} />
          <Route path="/chat" component={ChatScreen} />
          <Route path="/chatroom" component={Chat} />
          <Route path="/video/:chatId" component={Video} />
          <Route path="/como-funciona" component={ComoFunciona} />
          <Route path="/faq" component={FAQScreen} />
          <Route
            path="/categoria/:id/profissionais"
            component={ProfessionalByCategoryScreen}
          />
          <Route
            path="/categoria/:id/profissional/:professionalId"
            component={ProfessionalProfile}
          />
          {/* <Route path='/consults' component={ConsultsScreen} /> */}
        </Switch>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return bindActionCreators({ checkLoggedUser }, dispatch);
};
const mapStateToProps = state => {
  return {
    token: state.user.userInfo.token
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ControladorRotas);
